var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.PopupMapComponent
    ? _c(_setup.PopupMapComponent, { ref: "popupMapRef", tag: "component" })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }